export default __webpack_public_path__ + "static/tos-1.1b.2057.html";